// neil.js

// Sticky header
// Sticky header
document.addEventListener('scroll', () => {
    const header = document.getElementById('header');
    if (!header) return;

    if (window.scrollY >= 100) {
        header.classList.add('sticky');
    } else {
        header.classList.remove('sticky');
    }
});

// Booking popup
document.querySelectorAll('.js__booking').forEach(btn => {
    btn.addEventListener('click', () => {
        document.querySelector('#select-location-bg')?.classList.add('active');
        document.querySelector('#location-popup')?.classList.add('active');
        document.body.classList.add('overflow-hidden');
    });
});
document.querySelector('#location-popup .close')?.addEventListener('click', () => {
    document.querySelector('#select-location-bg')?.classList.remove('active');
    document.querySelector('#location-popup')?.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
});

document.addEventListener('DOMContentLoaded', function () {
    const select = document.getElementById('locationSelect');

    if (select) {
        select.addEventListener('change', function () {
            const url = this.value;
            if (!url) return;

            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            if (isMobile) {
                // open in same tab on mobile
                window.location.href = url;
            } else {
                // open in new tab on desktop
                window.open(url, '_blank');
            }
        });
    }
});




// Jobs filter (AJAX)
import axios from 'axios';
const jobForm = document.getElementById('job-filter-form');
if (jobForm) {
    const ajaxUrl = document.getElementById('ajax-url')?.value;
    const inputs = jobForm.querySelectorAll('.filter-input');

    const fetchFilteredJobs = () => {
        const formData = new FormData(jobForm);
        axios.post(ajaxUrl, new URLSearchParams({
            ...Object.fromEntries(formData),
            action: 'filter_jobs'
        }))
            .then(response => {
                document.getElementById('job-results').innerHTML = response.data;
            })
            .catch(err => console.error('AJAX Error:', err));
    };

    inputs.forEach(input => {
        ['change', 'keyup'].forEach(evt => input.addEventListener(evt, fetchFilteredJobs));
    });

    // Initial load
    fetchFilteredJobs();
}